import React from 'react'
import styled from 'styled-components/macro'

const Wrapper = styled.div`
  input {
    text-align: left;
    padding-left: 55px;
    font-size: 16px;
    border-width: 1px !important;

    ::placeholder {
      color: #939393;
    }
  }

  .searchitem:before {
    content: ' ';
    left: 20px;
    top: 10px;
    height: 24px;
    width: 24px;
    background-image: url('/img/search_black@2x.png');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 24px 24px;
  }
`

export const Searchbar: React.FC<React.ComponentProps<'input'>> = (props) => (
  <Wrapper className="formitem">
    <div className="searchitem">
      <input {...props} />
    </div>
  </Wrapper>
)
